export const ADD_SUCCESS = 'Команда успешно отправлена';
export const ADD_ERROR = 'Не удалось отправить команду';
